/* eslint-disable react-hooks/rules-of-hooks */
import React, { useState } from 'react';
import {
  TeamLogo,
  LargeButton,
  LoginWrapper,
  TextboxWarning,
  InputComponent,
} from '../../components';
import {
  LoginLogo,
  ResetPasswordForm,
  LoginRecovery,
  LoginLogoSpan,
  SuccessParagraphs,
  Label,
  ResetTitle,
  ResetParagraphs,
} from './styles';
import { Auth as AuthClass } from '../../utils/api/';
import { useInputValue } from '../../utils/hooks/useInputValue';
import { useNavigate } from 'react-router-dom';

export default () => {
  const Auth = new AuthClass();
  const navigate = useNavigate();

  const [loading, useLoading] = useState(false);
  const [emailSent, setEmailSend] = useState(false);
  const password = useInputValue('', 'eyeClose', '', '', 'password');

  function HandleFocus(input: any) {
    input.HandleWarning('');
    input.HandleStatus('normal');
  }

  function HandleIcon(hook: any) {
    if (hook.icon === 'eyeClose') {
      hook.HandleIcon('eyeOpen');
      hook.HandleType('text');
    } else if (hook.icon === 'eyeOpen') {
      hook.HandleIcon('eyeClose');
      hook.HandleType('password');
    }
  }


  const HandleResetPassword = async (e: any) => {
    e.preventDefault();
    if (!Boolean(password.value.length)) {
      password.HandleWarning('Fill the password information');
      password.HandleStatus('error');
    } else {
      useLoading(true);
      const urlParams = new URLSearchParams(window.location.search);
      const token = urlParams.get('token') as string;
      let response = await Auth.ResetPassword(token, password.value) as any;
      if (response.status) {
        setEmailSend(true)
      }
      useLoading(false);
    }
  }

  return (
    <>
      <LoginWrapper isLoading={loading} topLoader={250}>
        <LoginLogo>
          <TeamLogo mWidth="200px" mHeight="40px" />
          <LoginLogoSpan>Measure. Monitor. Optimize</LoginLogoSpan>
        </LoginLogo>
        <LoginRecovery>
          {!emailSent ? (
            <>
              <ResetTitle>Reset your password</ResetTitle>
              <ResetParagraphs><p>Enter your new password below.</p></ResetParagraphs>
              <Label>New password</Label>
              <ResetPasswordForm onSubmit={HandleResetPassword}>
                <InputComponent
                  fontSize={16}
                  disabled={loading}
                  bordeRadius={'4px'}
                  inputStyle={'dark'}
                  insetShadow="#F4F5F7"
                  dynamicSearch={password}
                  placeholder="password here"
                  backgroundColor={'#F4F5F7'}
                  colorPlaceholder={'#D8DDE3'}
                  HandleIcon={() => HandleIcon(password)}
                  HandleFocus={() => HandleFocus(password)}
                />
                <TextboxWarning
                  status={password.status}
                  title={password.warningTitle}
                  message={password.warningMessage}
                />
              </ResetPasswordForm>
              <LargeButton
                fullWidth
                lMargin="0"
                fSize={'16px'}
                bradius={'8px'}
                rColor="#017CFF"
                bColor="#FFFFFF"
                disabled={loading}
                xMargin={'5vh 0 0;'}
                title="Save password"
                callback={HandleResetPassword}
                colorDisabled={'#B3D7FF'}
              />
            </>
          ) : (
            <>
              <ResetTitle>Password reset successfully!</ResetTitle>
              <SuccessParagraphs>Your password had been reset. Log in</SuccessParagraphs>
              <LargeButton
                fullWidth
                lMargin="0"
                fSize={'16px'}
                bradius={'8px'}
                rColor="#017CFF"
                bColor="#FFFFFF"
                xMargin={'5vh 0 0;'}
                title="Go to Sign in"
                callback={() => navigate('/', { replace: true })}
              />
            </>
          )}
        </LoginRecovery>
      </LoginWrapper>
    </>
  );
};
